import React from 'react';
import senaface from '../../../assets/paige.jpeg';
import { Box, Container, Avatar, Typography, Stack } from '@mui/material';
import { Chat as ChatIcon, Phone as PhoneIcon, LocalFireDepartment as FireIcon } from '@mui/icons-material';
import { CustomButton } from '../../../common-components';
import { useNavigate } from 'react-router-dom';
import { QuestionCard } from '../../../common-components';
import useProductsProvider from '../../../layouts/MainLayout/hooks/useProductsProvider';
import { UseFormSetValue } from 'react-hook-form';
import { ROUTE_PATHS } from '../../../routes/constants';

interface NewChatProps {
  onSubmit: (data: any) => void;
  setValue: UseFormSetValue<any>;
  toggleToChat: () => void;
}
export const NewChat = (props: NewChatProps) => {
  const { onSubmit, setValue, toggleToChat } = props;
  const navigate = useNavigate();
  const { productBasedQuestions, currentProduct } = useProductsProvider();
  const demoVideoUrl = 'https://www.youtube.com/watch?v=1-sXHKJU_hI';

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 3,
          pb: 4,
        }}
      >
        {/* Profile Section */}
        <Box sx={{ position: 'relative', mt: 4 }}>
          <Avatar
            sx={{
              width: 120,
              height: 120,
            }}
            src={senaface}
            alt="Sena"
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              right: 8,
              width: 20,
              height: 20,
              backgroundColor: 'secondary.main',
              borderRadius: '50%',
              border: '3px solid #ffffff',
            }}
          />
        </Box>

        {/* Name and Description */}
        <Box>
          <Typography
            variant="h4"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              mb: 1,
            }}
          >
            Sena
            <FireIcon sx={{ fontSize: 32, color: 'primary.main' }} />
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            AI Data Assistant | Your Personal Consultant
          </Typography>
         {/* Lets make the bellow a link to redirect to a youtube video  */}
          <Typography component="a" href={demoVideoUrl} target="_blank" rel="noopener noreferrer" variant="body1" 
          sx={{ color: 'primary.main', textDecoration: 'underline', cursor: 'pointer' }}>
            See how you can chat with your data
          </Typography>
          
          
        </Box>

        {/* Action Buttons */}
        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <CustomButton startIcon={<ChatIcon />} variant="outlined" onClick={toggleToChat}>
            Chat
          </CustomButton>
          <CustomButton startIcon={<PhoneIcon />} onClick={() => navigate(ROUTE_PATHS.PORTAL_CALL)} variant="outlined">
            Call
          </CustomButton>
        </Stack>

        {/* Suggested Questions */}
        <Box sx={{ width: '100%', mt: 4 }}>
          <Typography
            variant="h6"
            sx={{
              textAlign: 'left',
              mb: 2,
            }}
          >
            Suggested Questions
          </Typography>
          <Stack spacing={1.5}>
            {productBasedQuestions[currentProduct]?.map((question, index) => (
              <QuestionCard
                key={index}
                question={question}
                onClick={() => {
                  setValue('message', question);
                  onSubmit({ message: question });
                  toggleToChat();
                }}
              />
            ))}
          </Stack>
        </Box>
      </Box>
    </Container>
  );
};
